import { useNotifyChange, useOnChange } from 'hooks/useChangeSignal';

// A form of a record page saved something (a note, a call, a contact…): the
// record reads itself again.
export const RECORD_CHANGED = 'record_changed';

export const useNotifyRecordChanged = () => useNotifyChange(RECORD_CHANGED);

const useRecordChanged = (onChanged) => useOnChange(RECORD_CHANGED, onChanged);

export default useRecordChanged;
